import React from 'react';
import { tomos } from '../data/content';
import { TransformCta } from './CtaButton';
export function Tomos() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-241" data-mp="13cz9rznqe99u">
      <div className="mx-auto max-w-4xl" data-id="element-242" data-mp="1h3m9nv58a57i">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-243" data-mp="1h4njxxef6no6">
          ¿Qué contiene la Ruta Fertilidad Masculina?
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-center text-[14px] leading-relaxed text-navy-800/70 sm:text-lg" data-id="element-244" data-mp="1r07by8pv527n">
          📘 6 Tomos Digitales que te acompañan desde la primera consulta hasta la resolución del
          caso.
        </p>

        <div className="mt-9 space-y-4" data-id="element-245" data-mp="1zzm4reti5ovb">
          {tomos.map(tomo => <article key={tomo.numero} className="rounded-3xl border border-navy-800/10 bg-cream p-5 shadow-card sm:p-7" data-id="element-246" data-mp="1w0v7n7p1e787">
              <span className="inline-block rounded-full bg-navy-900 px-3 py-1 text-[10px] font-extrabold uppercase tracking-widest text-gold-400 sm:text-xs" data-id="element-247" data-mp="1n3zkcmcvvev">
                📘 {tomo.numero}
              </span>
              <h3 className="mt-3 font-display text-xl font-black leading-tight text-navy-900 sm:text-2xl" data-id="element-248" data-mp="39qukxtaq669b">
                {tomo.titulo}
              </h3>
              <p className="mt-2 text-[14px] font-semibold leading-snug text-violet-700 sm:text-[16px]" data-id="element-249" data-mp="3jfmbpy41ukin">
                {tomo.promesa}
              </p>
              <p className="mt-2.5 text-[13.5px] leading-relaxed text-navy-800/75 sm:text-[15px]" data-id="element-250" data-mp="3oe5yu1udq2cl">
                {tomo.detalle}
              </p>
            </article>)}
        </div>

        <TransformCta headline="Accede hoy a los 6 tomos y resuelve tu próximo caso con criterio." data-id="element-251" data-mp="1baxjawqji26" />
      </div>
    </section>;
}